/**
 * Copyright © 2026 Adnuntius AS.
 */
import {CopyrightStatusComponent} from './copyright-status-component';
import {CreativeSetRecentlyRequestedComponent} from './creative-set-recently-requested-component';
import {CreativeStatusLabelComponent} from './creative-status-component';
import {LineItemDiagnosticLabelComponent} from './diagnostic-label-component';
import {LineItemExecutionLabelComponent} from './execution-component';
import {LineItemSmoothingLabelComponent} from './smoothing-label-component';
import {LineItemSourceLabelComponent} from './line-item-source-component';
import {LineItemStatusLabelComponent} from './status-component';
import {LineItemStatusExplanationLabelComponent} from './status-explanation-component';
import {ValidationInfoComponent} from './validation-info-component';
import {BidsViewComponent} from './widget/bids-view.component';
import {ObjectivesViewComponent} from './widget/objectives-view.component';

export const LINE_ITEM_LABELS = [
  LineItemSmoothingLabelComponent,
  LineItemDiagnosticLabelComponent,
  LineItemSourceLabelComponent,
  LineItemStatusLabelComponent,
  LineItemStatusExplanationLabelComponent,
  LineItemExecutionLabelComponent,
  ValidationInfoComponent,
  CopyrightStatusComponent,
  CreativeStatusLabelComponent,
  CreativeSetRecentlyRequestedComponent,
  ObjectivesViewComponent,
  BidsViewComponent
];
